import styled from 'styled-components';

export const ProcessContainer = styled.section`
  background: transparent;
  width: 100%;
  padding: 80px 0 0 0;
  min-height: 100vh;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 50px 0 0 0;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    padding: 40px 0 0 0;
  }
`;

export const ProcessContent = styled.div`
  max-width: 1200px;
  margin: 0 auto 28px;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    padding: 0 15px;
  }
  
  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

export const TopSection = styled.div`
  text-align: center;
  position: relative;
  padding-top: 60px;
  
  @media (max-width: 768px) {
    margin-bottom: 60px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

export const MainTitle = styled.h2`
  font-size: 2.2rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
  max-width: 890px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.3;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.6rem;
    margin-bottom: 15px;
    line-height: 1.4;
  }
  
  @media (max-width: 480px) {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
`;

export const VideoContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  perspective: 1000px;
  width: 100%;
  position: relative;
  height: 350px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    height: auto;
    padding: 20px 0;
  }
`;

export const VideoPlaceholder = styled.div`
  width: 400px;
  height: 280px;
  background: #333;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  cursor: pointer;
  transition: all 0.5s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  
  ${props => {
    if (props.position === 0) {
      return `
        transform: translateX(0) scale(1);
        z-index: 3;
        opacity: 1;
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
      `;
    } else if (props.position === 1 || props.position === -2) {
      return `
        transform: translateX(320px) scale(0.85) perspective(500px) rotateY(-15deg);
        z-index: 1;
        opacity: 0.7;
      `;
    } else if (props.position === -1 || props.position === 2) {
      return `
        transform: translateX(-320px) scale(0.85) perspective(500px) rotateY(15deg);
        z-index: 1;
        opacity: 0.7;
      `;
    } else {
      return `
        transform: translateX(${props.position > 0 ? '600px' : '-600px'}) scale(0.7);
        opacity: 0;
        pointer-events: none;
      `;
    }
  }}
  
  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    max-width: 350px;
    height: 220px;
    transform: none !important;
    opacity: 1 !important;
    margin-bottom: 1rem;
    z-index: 1 !important;
    display: ${props => props.position === 0 ? 'flex' : 'none'};
  }
  
  @media (max-width: 480px) {
    max-width: 300px;
    height: 180px;
  }
`;

export const PlayButton = styled.div`
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #333;
  transition: all 0.3s ease;
  
  &:hover {
    background: #fff;
    transform: scale(1.1);
  }
`;

export const VideoNavigation = styled.div`
  display: flex;
  gap: 10px;
  z-index: 5;
`;

export const NavDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.active ? '#007bff' : '#ccc'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.active ? '#007bff' : '#aaa'};
    transform: scale(1.2);
  }
`;

export const BottomSection = styled.div`
  text-align: center;
`;

export const SectionTitle = styled.h2`
  font-size: 2.8rem;
  color: #333;
  margin-bottom: 25px;
  font-weight: 700;
  line-height: 1.2;
  white-space: normal;
  word-break: keep-all;
  
  strong {
    color: #007bff;
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  @media (max-width: 1024px) {
    font-size: 2.4rem;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 2.0rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 80px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 50px;
    max-width: 100%;
    padding: 0 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 40px;
  }
`;

export const StepsContainer = styled.div`
  margin-bottom: 0px; 
  padding: 0 20px;
  
  @media (max-width: 768px) {
    margin-bottom: 0px;
    padding: 0 10px;
  }
`;

export const WomanSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0; 
  
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    margin: 0;
  }
  
  @media (max-width: 768px) {
    margin: 0;
    padding: 20px 0;
  }
`;

export const WomanImage = styled.img`
  width: 700px;
  height: auto;
  border-radius: 20px;
  transition: all 0.3s ease;
  
  @media (max-width: 1024px) {
    width: 600px;
    margin-bottom: 30px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 350px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    max-width: 300px;
  }
`;

export const FloatingCard = styled.div`
  position: absolute;
  background: #1a1a1a;
  color: white;
  padding: 25px;
  border-radius: 20px;
  width: 320px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
  }
  
  &.step1 {
    top: -5%;
    left: 3%;
    
    @media (max-width: 1200px) {
      left: 5%;
    }
    
    @media (max-width: 1024px) {
      position: relative;
      left: 0;
      top: 0;
      margin: 0 auto 20px auto;
      width: 100%;
      max-width: 350px;
    }
    
    @media (max-width: 768px) {
      width: 100%;
      max-width: 320px;
      margin: 0 auto 15px auto;
      padding: 20px;
    }
  }
  
  &.step2 {
    top: 2%;
    right: 4%;
    
    @media (max-width: 1200px) {
      right: 5%;
    }
    
    @media (max-width: 1024px) {
      position: relative;
      right: 0;
      top: 0;
      margin: 0 auto 20px auto;
      width: 100%;
      max-width: 350px;
    }
    
    @media (max-width: 768px) {
      width: 100%;
      max-width: 320px;
      margin: 0 auto 15px auto;
      padding: 20px;
    }
  }
  
  &.step3 {
    top: 55%;
    right: 0;
    
    @media (max-width: 1200px) {
      right: 3%;
    }
    
    @media (max-width: 1024px) {
      position: relative;
      right: 0;
      top: 0;
      margin: 0 auto 20px auto;
      width: 100%;
      max-width: 350px;
    }
    
    @media (max-width: 768px) {
      width: 100%;
      max-width: 320px;
      margin: 0 auto 0 auto;
      padding: 20px;
    }
  }
`;

export const TrustSection = styled.div`
  background: linear-gradient(135deg, #010206 0%, #011E50 100%);
  color: white;
  padding: 40px;
  border-radius: 20px;
  margin-top: 0px;
  display: flex;
  align-items: center;
  gap: 40px;
  max-width: 1600px;
  height: 320px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 1650px) {
    max-width: 95%;
    height: auto;
    min-height: 280px;
    padding: 30px;
    border-radius: 15px;
  }
  
  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
    gap: 30px;
    padding: 30px;
    height: auto;
    min-height: auto;
  }
  
  @media (max-width: 768px) {
    padding: 25px 20px;
    border-radius: 15px;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 90%;
  }
  
  @media (max-width: 480px) {
    padding: 20px 15px;
    border-radius: 10px;
    height: auto;
    min-height: auto;
  }
`;

export const TrustTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0;
  line-height: 1.2;
  text-align: left;
  flex-shrink: 0;
  width: 400px;
  
  @media (max-width: 1024px) {
    text-align: center;
    font-size: 2rem;
    width: auto;
    margin-bottom: 20px;
  }
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2.0rem;
  }
`;

export const TrustCards = styled.div`
  display: flex;
  gap: 0;
  flex: 1; 
  border-radius: 8px;
  overflow: hidden;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 0;
    width: 100%;
    height: auto;
  }
`;

export const TrustCard = styled.div`
  flex: 1;
  background: #201F1F;
  padding: 20px;
  text-align: left;
  border-right: 2px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 270px;
  max-height: 376px;
  border-radius: 8px;
  
  &:last-child {
    border-right: none;
  }
  
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  
  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  
  .icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    font-size: 1.1rem;
    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
    flex-shrink: 0;
  }
  
  h4 {
    font-size: 0.95rem;
    margin-bottom: 8px;
    color: #fff;
    font-weight: 600;
    line-height: 1.2;
  }
  
  p {
    font-size: 0.8rem;
    line-height: 1.3;
    opacity: 0.9;
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
  }
  
  @media (max-width: 1024px) {
    text-align: center;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding: 20px 15px;
    width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 10px;
    
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
    
    &:first-child {
      border-radius: 8px;
    }
    
    &:last-child {
      border-radius: 8px;
    }
    
    .icon {
      margin: 0 auto 12px auto;
    }
  }
  
  @media (max-width: 768px) {
    padding: 18px 12px;
    
    .icon {
      width: 36px;
      height: 36px;
    }
    
    h4 {
      font-size: 0.9rem;
    }
    
    p {
      font-size: 0.75rem;
    }
  }
  
  @media (max-width: 480px) {
    padding: 15px 10px;
    
    .icon {
      width: 32px;
      height: 32px;
    }
    
    h4 {
      font-size: 0.85rem;
    }
    
    p {
      font-size: 0.7rem;
    }
  }
`;

export const StepNumber = styled.div`
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
`;

export const CardTitle = styled.h4`
  font-size: 1.3rem;
  margin-bottom: 12px;
  color: #fff;
  font-weight: 600;
  line-height: 1.3;
`;

export const CardDescription = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  opacity: 0.9;
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
`;
export const StepCard = styled.div``;
export const StepTitle = styled.h4``;
export const StepDescription = styled.p``;
export const AvatarGroup = styled.div`
  margin-bottom: 40px;
  
  img {
    max-width: 300px;
    width: 100%;
    height: auto;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 30px;
    
    img {
      max-width: 250px;
    }
  }
  
  @media (max-width: 480px) {
    margin-bottom: 20px;
    
    img {
      max-width: 200px;
    }
  }
`;

export const Subtitle = styled.h3`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 15px;
  font-weight: 400;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 10px;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 40px;
  max-width: 880px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 30px;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    margin-bottom: 25px;
  }
`;

export const VideoSection = styled.div`
  margin: 3rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  overflow: hidden;
  padding: 2rem 0;
  
  @media (max-width: 768px) {
    margin: 2rem 0;
    gap: 1.5rem;
    padding: 1.5rem 0;
  }
  
  @media (max-width: 480px) {
    margin: 1.5rem 0;
    gap: 1rem;
    padding: 1rem 0;
  }
`;
